import { gql } from '@grandvisionhq/graphql';

const openCloseTimePair = gql`
  fragment OpenCloseTimePair on OpenCloseTimeStringPair {
    open
    close
  }
`;

export { openCloseTimePair };
//# sourceMappingURL=opening-hours.js.map
